export default "__VITE_ASSET__DdGNBteE__"